import { Pizza, Utensils, Flame, Disc3, MicVocal, Martini, Camera, Beef, LayoutGrid } from "lucide-react";

const ICONS = { pizza: Pizza, utensils: Utensils, flame: Flame, "disc-3": Disc3, "mic-vocal": MicVocal, martini: Martini, camera: Camera, beef: Beef };

export const CategoryPills = ({ categories, active, onChange }) => {
  const all = [{ slug: "alle", name: "Alle", icon: "grid", count: null }, ...categories];
  return (
    <div className="flex gap-2.5 overflow-x-auto pb-2 no-scrollbar" data-testid="category-pills">
      {all.map((c) => {
        const Icon = c.slug === "alle" ? LayoutGrid : ICONS[c.icon] || Utensils;
        const isActive = active === c.slug;
        return (
          <button
            key={c.slug}
            data-testid={`category-${c.slug}`}
            onClick={() => onChange(c.slug)}
            className={`flex items-center gap-2 whitespace-nowrap px-4 py-2.5 rounded-full border text-sm font-semibold transition-all
              ${isActive ? "bg-emerald-600 text-white border-emerald-600 shadow-sm" : "bg-white text-slate-700 border-slate-200 hover:border-emerald-500 hover:text-emerald-700"}`}
          >
            <Icon className="w-4 h-4" />
            {c.name}
            {c.count != null && <span className={`text-xs ${isActive ? "text-emerald-100" : "text-slate-400"}`}>({c.count})</span>}
          </button>
        );
      })}
    </div>
  );
};
